"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHoseCodes = void 0;
const ensureHeterotopicChiralBonds_js_1 = require("../diastereotopic/ensureHeterotopicChiralBonds.js");
const tagAtom_1 = require("../util/tagAtom");
const getHoseCodesForAtomsInternal_js_1 = require("./getHoseCodesForAtomsInternal.js");
/**
 * Returns the hose codes for all atoms in the molecule
 * @param {*} molecule
 * @param {object} [options={}]
 * @param {string[]} [options.atomLabels]
 * @param {number} [options.minSphereSize=0]
 * @param {number} [options.maxSphereSize=4]
 * @returns
 */
function getHoseCodes(molecule, options = {}) {
    const { atomLabels, minSphereSize, maxSphereSize } = options;
    const { Molecule } = molecule.getOCL();
    const atomicNumbers = atomLabels?.map((label) => Molecule.getAtomicNoFromLabel(label));
    const internalMolecule = molecule.getCompactCopy();
    internalMolecule.addImplicitHydrogens();
    (0, ensureHeterotopicChiralBonds_js_1.ensureHeterotopicChiralBonds)(internalMolecule);
    const hoses = [];
    for (let i = 0; i < internalMolecule.getAllAtoms(); i++) {
        if (atomicNumbers &&
            !atomicNumbers.includes(internalMolecule.getAtomicNo(i))) {
            hoses.push(undefined);
        }
        else {
            const tempMolecule = internalMolecule.getCompactCopy();
            (0, tagAtom_1.tagAtom)(tempMolecule, i);
            hoses.push((0, getHoseCodesForAtomsInternal_js_1.getHoseCodesForAtomsInternal)(tempMolecule, {
                minSphereSize,
                maxSphereSize,
            }));
        }
    }
    return hoses;
}
exports.getHoseCodes = getHoseCodes;
//# sourceMappingURL=getHoseCodes.js.map